<template>
<div class="page">
  <h1>Metrics</h1>
  <h2>{{month}}</h2>
  <p><span class='number'>{{currentBusinessViews}}</span> visits to your site.<p>
  <p><span class='number'>{{referredPartnerViews}}</span> people clicked through to a partner site.</p>
  <p><span class='number'>{{referredPurchases}}</span> referred purchases.</p>
  <p>Total estimated earnings: <span class='number earnings'>{{estimatedEarnings}}</span></p>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

export default {
  name: 'Metrics',

  computed: {
    ...mapGetters(['currentBusinessViews', 'referredPartnerViews', 'referredPurchases', 'estimatedEarnings']),
    month: () => months[(new Date()).getMonth()] + ' ' + ((new Date()).getYear() + 1900)
  }
}
</script>

<style scoped>
.number {
  margin-right: 4px;
  font-weight: bold;
}
.earnings {
  font-size: 24px;
}
p {
  font-size: 20px;
  margin: 30px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Metrics.vue